import React from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import SeoNoIndex from "../../components/helpers/SeoNoIndex";

const NotFound = () => {
  return (
    <>
      <SeoNoIndex noindex={true} />

      <div className="position-relative">
        <section className="section section-lg section-shaped pb-250">
          <div className="shape shape-style-1 shape-default">
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
            <span />
          </div>
          <Container className="py-lg-md d-flex">
            <div className="col px-0">
              <Row>
                <Col lg="8">
                  <h1 className="display-3 text-white">
                    Building your song-flows{" "}
                    <span>page not found</span>
                  </h1>
                </Col>
              </Row>
            </div>
          </Container>
          <div className="separator separator-bottom separator-skew">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon className="fill-white" points="2560 0 2560 100 0 100" />
            </svg>
          </div>
        </section>
      </div>

      <section className="section section-lg pt-lg-0 mt--200">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
              <Row className="row-grid">
                <Col lg="8">
                  <Card className="shadow border-0">
                    <CardBody className="py-2">
                      <Row>
                        <Col>
                          <h2
                            style={{ fontSize: "1rem" }}
                            className="text-primary text-uppercase pt-3 pb-3"
                          >
                            Page not found
                          </h2>
                        </Col>
                      </Row>
                      <p className="MsoNormal">
                        We could not find that page. It may have moved, or the
                        address may be incorrect.
                      </p>
                      <p className="MsoNormal">
                        You can return to the home page and continue planning
                        worship around scripture.
                      </p>
                      <p className="MsoNormal">
                        "Your word is a lamp for my feet, a light on my path."
                        — Psalm 119:105
                      </p>
                      <div className="pb-3">
                        <Button color="primary" href="/">
                          Return home
                        </Button>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default NotFound;
